import { Api } from '../typings/api';

export interface ResolvedStaleOfflineCleanupConfig {
	enabled: boolean;
	autoCleanDefault: boolean;
	showCleanupNotification: boolean;
}

const defaultStaleOfflineCleanupConfig: ResolvedStaleOfflineCleanupConfig = {
	enabled: true,
	autoCleanDefault: true,
	showCleanupNotification: true,
};

export const getStaleOfflineCleanupConfig = (
	config?: Api.Config,
): ResolvedStaleOfflineCleanupConfig => {
	if (!config) {
		return {
			...defaultStaleOfflineCleanupConfig,
			enabled: false,
		};
	}

	const staleConfig = config.offlineDownload
		&& config.offlineDownload.staleOfflineCleanup;

	return {
		enabled: !(staleConfig && staleConfig.enabled === false),
		autoCleanDefault: !(staleConfig && staleConfig.autoCleanDefault === false),
		showCleanupNotification: !(staleConfig && staleConfig.showCleanupNotification === false),
	};
};

export const isStaleOfflineCleanupEnabled = (config?: Api.Config): boolean =>
	getStaleOfflineCleanupConfig(config).enabled;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/staleOfflineCleanupConfig.ts